export function toUrl(url){

	const hasPortalInUrl = window.location.href.match(/\/portal/);
	if(hasPortalInUrl)
		return '/portal'+url;
	return url;
}